import { config } from '@/config/config';
import { AuthSession } from '@singular-health/models';
import { InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

export function beforeRequest(req: InternalAxiosRequestConfig) {
  const cookieName = config.cookieName;
  const sessionJson = Cookies.get(cookieName);
  if (sessionJson) {
    const session = JSON.parse(sessionJson) as AuthSession;
    req.headers['Authorization'] = `Bearer ${session.access_token}`;
  }

  return req;
}
